import SearchIcon from "../../assets/images/Search.svg";
import DropdownIcon from "../../assets/images/Dropdown.svg";
import { IReport } from "../../helpers/Interfaces";
import { convertDuration, getPriority, validDateField, validStringField } from "../../helpers/HelperFunctions";
import { Fragment, useCallback, useState } from "react";
import RemoveFilter from "../../assets/images/RemoveFilter.svg";
import { ReportFilterTypes } from "../../helpers/Types";
import SearchableDown from "../../components/SearchableDown/SearchableDown";
import RightArrow from "../../assets/images/ArrowRight.svg";

import "./Reports.scss";

export default function PendingReportsUI(props: {
  reports: IReport[], setSelectedReport: CallableFunction;
  openView: CallableFunction; filter: (filterBy: ReportFilterTypes, query: string) => void;
  cancelFilter: boolean; resetDefault: CallableFunction
}) {

  const [anchorSearcherEl, setAnchorSearcherEl] = useState<HTMLImageElement>(null as any);
  const [selectedFilter, setSelectedFilter] = useState<ReportFilterTypes>("patientName");
  const [showSearch, setShowSearch] = useState(true);
  const [isAscending, setIsAscending] = useState(true);

  const openSearch = Boolean(anchorSearcherEl);

  const handleClickView = useCallback((selectedReport: IReport) => {
    props.setSelectedReport(selectedReport);
    props.openView("view");
  }, []);
  const handleSearchOpen = (event: React.MouseEvent<HTMLImageElement>, filterBy: ReportFilterTypes) => {
    setAnchorSearcherEl(event.currentTarget);
    setSelectedFilter(filterBy);
  };

  const handleSearchClose = () => {
    setAnchorSearcherEl(null as any);
    setShowSearch(true);
  };

  const handleSelectedItem = (selectedValue: string) => {
    props.filter(selectedFilter, selectedValue);
    setAnchorSearcherEl(null as any);
    setShowSearch(true);
  };

  const handleClearFilter = () => {
    props.resetDefault()
  };

  function getInitialValues() {

    let valueArr = [] as any[];

    props.reports.forEach(report => {
      valueArr.push(report[selectedFilter])
    });

    let distinctValues = valueArr.filter((value, index, array) => array.indexOf(value) === index);

    return distinctValues;
  }

  function getSortedReports() {
    const allReports = [...props.reports];

    return allReports.sort((a, b) => {
      const timeA = a.dateOfAssessment ? new Date(a.dateOfAssessment).getTime() : Infinity;
      const timeB = b.dateOfAssessment ? new Date(b.dateOfAssessment).getTime() : Infinity;

      return isAscending ? timeA - timeB : timeB - timeA;
    });
  }

  return (
    <div className="table animated animatedFadeInUp fadeInUp">
      <div className="header">
        <div className="header-row large">
          <span className="large-text">Patient Name</span>
          <img onClick={(value) => handleSearchOpen(value, "patientName")} className="icon" src={SearchIcon} alt={"Search"} />
        </div>
        <div className="header-row small">
          <span className="large-text">Report Type</span>
          <img onClick={(value) => handleSearchOpen(value, "reportType")} className="icon" src={SearchIcon} alt={"Search"} />
        </div>
        <div className="header-row small">
          <span className="large-text">Referrer</span>
          <img onClick={(value) => handleSearchOpen(value, "referrer")} className="icon" src={SearchIcon} alt={"Search"} />
        </div>
        <div className="header-row large">
          <span className="large-text">Date of Assessment</span>
          <img onClick={() => setIsAscending(!isAscending)} src={DropdownIcon} alt="SortArrow" className={isAscending ? "img" : "invert-img"} />
        </div>
        <div className="header-row small">
          <span className="large-text">Due Date</span>
        </div>
        <div className="header-row small">
          <span className="large-text">Audio Duration</span>
        </div>
        <div className="header-row small">
          <span className="large-text">Urgency</span>
          <img onClick={(value) => { handleSearchOpen(value, "priority"); setShowSearch(false); }}
            className="icon" src={DropdownIcon} alt={"Dropdown"} />
        </div>
        <div className="header-row small">
          <div className="filter-content">
            {props.cancelFilter
              ? <img className="filter-icon" src={RemoveFilter} alt={"RemoveFilter"} onClick={handleClearFilter} />
              : <div className="filter-icon" />
            }
          </div>
        </div>
      </div>
      <div className="data animated animatedFadeInUp fadeInUp">
        {getSortedReports().map((report) => {
          return (<div key={report.id} className="data-row" onClick={() => { handleClickView(report); }}>
            <span className="cell large-text large">{validStringField(report.patientName)}</span>
            <span className="cell large-text small">{validStringField(report.reportType)}</span>
            <span className="cell large-text small">{validStringField(report.referrer)}</span>
            <span className="cell large-text large">{validDateField(report.dateOfAssessment)}</span>
            <span className="cell large-text small">
              {validDateField(report.dueDate)}
            </span>
            <span className="cell large-text small">{convertDuration(report.totalDuration)}</span>
            <span className="cell large-text small">{getPriority(report.priority)}</span>
            <span className="cell large-text small flex-end">
              <div>
                <img className="action" src={RightArrow} alt={"RightArrow"} />
              </div>
            </span>
          </div>);
        })}
      </div>

      {openSearch
        ? (<SearchableDown open={openSearch} anchorEl={anchorSearcherEl} onClose={handleSearchClose}
          initialDetails={getInitialValues()} onClick={(selectedValue: string) => { handleSelectedItem(selectedValue); }}
          searchable={showSearch} />)
        : (<Fragment />)
      }
    </div>
  )
}

